import { render } from "./LocalizedHtmlEditor.vue?vue&type=template&id=e2707cf2&scoped=true"
import script from "./LocalizedHtmlEditor.vue?vue&type=script&lang=js"
export * from "./LocalizedHtmlEditor.vue?vue&type=script&lang=js"

import "./LocalizedHtmlEditor.vue?vue&type=style&index=0&id=e2707cf2&scoped=true&lang=css"

import exportComponent from "/github/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2707cf2"]])

export default __exports__